import { render, staticRenderFns } from "./rewardLevel.vue?vue&type=template&id=a71b5e1e&scoped=true&"
import script from "./rewardLevel.vue?vue&type=script&lang=js&"
export * from "./rewardLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71b5e1e",
  null
  
)

export default component.exports